export default __webpack_public_path__ + "static/media/logo.faea7efa.svg";